import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=c06b480c&"
import script from "./js/create.js?vue&type=script&lang=js&"
export * from "./js/create.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports